import { Component, OnInit } from "@angular/core"
import { ConfigService } from "src/app/shared/services/config.service"
import { isMobile } from "src/app/shared/utils/helpers"
import { LoggedService } from "src/app/shared/services/logged.service"
import { SidenavService } from "src/app/shared/services/sidenav.service"

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html'
})
export class PageNotFoundComponent implements OnInit {

  public Etiquetas: {
    PageNotFound: {
      ButtonText: string
      LeadText1: string,
      LeadText2: string,
      Text1: string,
    },
    Login: {
      Titulo: string
    }
  }

  constructor(
    private loggedService: LoggedService,
    private sidenav: SidenavService,
    private configService: ConfigService,
  ) { }

  ngOnInit() {
    this.Etiquetas = {
      Login:
      {
        Titulo: this.configService.etiquetas.Login.Titulo
      },
      PageNotFound:
      {
        ButtonText: this.configService.etiquetas.PageNotFound.ButtonText,
        LeadText1: this.configService.etiquetas.PageNotFound.LeadText1,
        LeadText2: this.configService.etiquetas.PageNotFound.LeadText2,
        Text1: this.configService.etiquetas.PageNotFound.Text1,
      }
    }
  }

  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }

  isMobile() {
    return isMobile();
  }

  toggleRightSidenav() {
    this.sidenav.toggle();
  }

  logOut() {
  localStorage.setItem('logoutLogs', JSON.stringify(
      {
        timestamp: new Date(),
        reasonId: 0,
        source: 'page-not-found.component.ts'
      }
    ));
    
    this.loggedService.logOut(0);
  }

}
